<template>
  <div ref="contextMenu" class="context-menu-holder" v-show="getContextVisible">
    <div class="context-menu-option" @click="handleSplit">Split</div>
    <div class="context-divider"/>
    <SegmentColor ref="colorSelect" :segment="getSegment" :show="true" :type="this.type" :format="'context'"/>
    <div class="context-divider"/>
    <div class="context-menu-option" @click="handleRemove" >Remove</div>
  </div>
</template>

<script>
import { useSegmentStore } from '@/store/SegmentStore';
import SegmentColor from '@/components/layout/SegmentColor';
import { nextTick } from 'vue';

export default {
  name: 'ContextMenu',
  components: {
    SegmentColor
  },
  data () {
    return {
      type: null
    };
  },
  mounted () {
    let editor = document.getElementById('pipeEditor');
    editor.addEventListener('contextmenu', this.handleContextMenu);
  },
  computed: {
    getContextVisible () {
      return useSegmentStore().getContextVisible;
    },
    getSegment () {
      const segmentStore = useSegmentStore();
      let num = (this.type === 'pipe') ? segmentStore.getPreviousPipeNum : segmentStore.getPreviousSlopeNum;
      let segment = segmentStore.getSegmentOfType(this.type, num);
      return (segment !== undefined) ? segment : { color: '#ff0000' };
    }
  },
  methods: {
    handleContextMenu (e) {
      if (e.target.nodeName !== 'rect') { return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      this.type = (e.target.attributes.id.value.charAt(0) === 'p') ? 'pipe' : 'slope';
      let editor = document.getElementById('pipeEditor');
      const segmentStore = useSegmentStore();
      let offset = (segmentStore.getPipeEditorHeight / 2) + editor.getBoundingClientRect().top;
      nextTick(() => {
        const adjustment = e.clientY > offset ? 130 : 0;
        this.$refs.contextMenu.style.top = e.clientY - adjustment + 'px';
      });
      this.$refs.contextMenu.style.left = e.clientX  + 5 + 'px';
      editor.addEventListener('mousedown', this.handleMouseDown);
      editor.addEventListener('keypress', this.handleKeyPress);
      segmentStore.setContextVisible(true);
    },
    handleMouseDown () {
      let editor = document.getElementById('pipeEditor');
      editor.removeEventListener('mousedown', this.handleMouseDown);
      useSegmentStore().setContextVisible(false);
    },
    handleSplit () {
      const segmentStore = useSegmentStore();
      const position = segmentStore.getSplitPosition;
      if (this.type == 'pipe') {
        segmentStore.splitPipe(position);
      } else if (this.type == 'slope') {
        segmentStore.splitSlope(position);
      }
      this.handleMouseDown();
    },
    handleRemove () {
      useSegmentStore().removePreviousSegmentOfType(this.type);
      this.handleMouseDown();
    },
  }
};
</script>

<style scoped>
.context-menu-holder {
  background-color: white;
  position:absolute;
  width: 90px;
  z-index:1000;
  font-weight: 700;
  font-size: 80%;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  -webkit-box-shadow: 3px 3px 7px 0px rgba(0,0,0,0.2);
  box-shadow: 3px 3px 7px 0px rgba(0,0,0,0.2);
}
.context-menu-option {
  cursor: pointer;
  user-select: none;
}
.context-menu-option:hover {
  background-color: whitesmoke;
}
.context-divider {
  width: 100%;
  height: .5px;
  background-color: #444343;
}
</style>